import CashCard from 'components/ui-kit/CashCard'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import DepositCurrencySection from './DepositCurrencySection'
import { useOnramper } from 'hooks/useOnramper'
import DepositBuyCrypto from './DepositBuyCrypto'

// Double background (padding-box fill + border-box gradient) paints the gold
// border. Keep each arbitrary class as one unbroken literal for Tailwind.
const WALLET_CARD =
  'mb-1 w-full box-border px-1 rounded-lg border border-solid border-transparent ' +
  'shadow-[inset_0_1px_0_rgb(var(--pm-gold)/0.06)] animate-pm-fade-in-up motion-reduce:animate-none ' +
  '[transition:box-shadow_var(--pm-duration-fast,0.16s)_var(--pm-ease,ease),transform_var(--pm-duration,0.24s)_var(--pm-ease-spring,ease)] ' +
  '[background:linear-gradient(145deg,#472e00,#090b0b_25%)_padding-box,linear-gradient(135deg,#8a6500,#ffd700,#b8860b,#b8860b,#8a6500)_border-box] ' +
  'hover:-translate-y-0.5 ' +
  'hover:[background:linear-gradient(145deg,#472e00,#090b0b_35%)_padding-box,linear-gradient(135deg,#8a6500,#ffd700,#b8860b,#b8860b,#8a6500)_border-box] ' +
  'hover:shadow-[inset_0_1px_0_rgb(var(--pm-gold)/0.1),0_6px_18px_rgb(var(--color-shadow)/0.18)]'

const CashierDeposit = () => {
  const { t } = useTranslation()
  const [selectedWallet, setSelectedWallet] = useState(null)
  const { user } = useSelector((state) => state.user)
  const { showOnramperWidget } = useOnramper()

  useEffect(() => {
    if (selectedWallet) {
      const [wallet] = user?.wallets?.filter(wallet => wallet?.currencyId === selectedWallet?.currencyId)
      setSelectedWallet(wallet)
    }
  }, [user])

  useEffect(() => {
    return () => { setSelectedWallet(null) }
  }, [])

  return (
    <div
      id='pills-cashier-deposit'
      role='tabpanel'
      aria-labelledby='pills-cashier-deposit-tab'
      tabIndex='0'
    >
      {!selectedWallet
        ? (
          <div>
            <div className='mb-6 flex items-center max-md:mb-4 max-md:flex-col max-md:items-start max-md:gap-y-4'>
              <h3 className='mb-0 flex items-center text-xl font-bold uppercase text-white max-md:text-base'>{t('depositOptions')}</h3>
            </div>
            <div>
              <div className='grid grid-cols-1 sm:grid-cols-2 gap-3'>
                {user?.wallets
                  ?.filter((wallet) => !wallet?.currency?.isFiat && wallet?.currency?.isActive !== false)
                  ?.map((wallet) => (
                    <div
                      key={wallet?.currencyId}
                      className={WALLET_CARD}
                    >
                      <CashCard
                        onClick={() => {
                          setSelectedWallet(wallet)
                        }} title={wallet.currency.name} image={wallet.currency.image} desc={wallet.currency.code}
                      />
                    </div>
                  ))}
              </div>
            </div>
            <DepositBuyCrypto currencyName='Crypto' buttonType='secondary' showOnramperWidget={showOnramperWidget} currencyCode='ETH' />
          </div>
          )
        : (
          <DepositCurrencySection
            selectedWallet={selectedWallet}
            setSelectedWallet={setSelectedWallet}
          />
          )}
    </div>
  )
}

export default CashierDeposit
